import { Component, effect, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { selectTeams } from '../../../../store/selectors/teams.selectors';
import { selectCompetitions } from '../../../../store/selectors/competitions.selectors';
import { selectSports } from '../../../../store/selectors/sport.selectors';
import { toSignal } from '@angular/core/rxjs-interop';
import { PredictionFormComponent } from '../prediction-form/prediction-form.component';
import { PredictionService } from '../../../../services/prediction.service';
import { selectSelectedPrediction } from '../../../../store/selectors/prediction.selectors';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-edit-prediction',
  imports: [PredictionFormComponent],
  templateUrl: './edit-prediction.component.html',
  styleUrl: './edit-prediction.component.scss'
})
export class EditPredictionComponent {
  private store = inject(Store);
  private route = inject(ActivatedRoute);
  private messageService = inject(MessageService);
  private predictionService = inject(PredictionService);
  predictionId: string = this.route.snapshot.paramMap.get('id') || '';
  customErrors = {
    isEqualTeams: false
  };

  teams = toSignal(this.store.select(selectTeams));
  competitions = toSignal(this.store.select(selectCompetitions));
  sports = toSignal(this.store.select(selectSports));
  prediction = toSignal(this.store.select(selectSelectedPrediction))

  onUpdate(updatedData: any): void {
    this.predictionId = this.route.snapshot.paramMap.get('id') || '';
    this.customErrors = {
      isEqualTeams: updatedData.teamHomeName === updatedData.teamAwayName
    };
    if (  this.customErrors.isEqualTeams) return;
    const predictionInfo = {

      "sport": updatedData.sport,
      "competition": updatedData.competition,
      "team_home": updatedData.teamHomeName,
      "team_away": updatedData.teamAwayName,
      "confidence_team_home": updatedData.teamHomeConfidence ? updatedData.teamHomeConfidence / 100 : 0,
      "confidence_team_away": updatedData.teamAwayConfidence ? updatedData.teamAwayConfidence / 100 : 0,
      "event_date": updatedData.eventDate,
      "event_name": updatedData.eventName,
      "analysis_text": updatedData.analysisText,
      "result": updatedData.result,
      "cote": updatedData.cote

    };


    this.predictionService.editPrediction(this.predictionId, predictionInfo).subscribe({
      next: response => {
        this.messageService.add({
          severity: 'success',
          summary: 'Successful',
          detail: 'Prédiction modifiée avec succès',
          life: 3000
        });
      },
      error: err => {
        console.error('Error updating prediction:', err);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Erreur lors de la modification de la prédiction',
          life: 3000
        });
      }
    })


  }
}
